<template>
  <div id="preview-map" class="location" data-latitude="0" data-longitude="0">
    <img class="location__map" :src="googleImage" alt="Google Image" />
    <div
      class="modal fade lg entity-modal entity-modal_fullheight--md"
      id="room-display-map"
      tabindex="-1"
      role="dialog"
      style="display: none"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content modal-map-poi">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span></span>
            <span></span>
          </button>
          <div class="modal-header bg-color-white px-8">
            <p class="h5 modal-title color-black text-bold">
              {{ title }}
            </p>
          </div>
          <div class="modal-body position-relative">
            <div id="room-display-hotel-map"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { assetsUrl, apiKey, apiSignature } from '@/infrastructure/Configuration'
import { signUrl } from '@/infrastructure/urlSigner'

export default {
  name: 'PreviewMap',
  props: {
    title: {
      type: String,
      default: ''
    },
    marker: {
      type: String,
      default: 'marker'
    },
    coordinates: {
      type: Object
    }
  },
  data() {
    return {
      googleImage: ''
    }
  },
  async mounted() {
    const coordinates = this.coordinates || { latitude: 0, longitude: 0 }
    const { latitude: lat, longitude: lng } = coordinates
    const mapMarkerIcon = this.marker
      ? `${assetsUrl}/img/icons/markers/${this.marker}.png`
      : `${assetsUrl}/img/icons/markers/marker.png`

    const unsignedUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=13&scale=2&size=310x250&maptype=roadmap&format=png&markers=icon:${encodeURIComponent(mapMarkerIcon)}%7C${lat},${lng}&key=${apiKey}`

    const signedUrl = await signUrl(unsignedUrl, apiSignature)
    this.googleImage = signedUrl

    global._loadMapsScript(() => {
      const map = new global.MapControl('.location__map', {
        center: coordinates,
        mapTypeControl: false,
        navigationControl: false,
        panControl: false,
        zoomControl: false,
        typeControl: false,
        scaleControl: false,
        draggable: false,
        fullscreenControl: false,
        zoom: 13
      })

      map.addMarker(global.MapControl.buildMarker(coordinates, mapMarkerIcon))

      const hotelMarker = global.MapControl.buildMarker(coordinates, mapMarkerIcon)
      map.setMarker(hotelMarker)

      global.$('.location').on('click', function () {
        global.$('#room-display-map').modal('show')
      })

      global.$('#room-display-map').on('show.bs.modal', function () {
        const map = new global.MapControl('#room-display-hotel-map', {
          center: coordinates,
          zoom: 13
        })

        const hotelMarker = global.MapControl.buildMarker(coordinates, mapMarkerIcon)
        map.setMarker(hotelMarker)
        global.$('#room-display-map').off('show.bs.modal')
      })
    })
  }
}
</script>

<style scoped>
.location {
  height: 250px;
  cursor: pointer;
}
img {
  height: 250px !important;
  width: 100%;
  object-fit: cover;
}
</style>
